import { cn } from "../../util/base.util";

export default function UserAvatar({id, size, className}: {
    id: number;
    size?: "xs"|"sm"|"md"|"lg"|"xl";
    className?: string;
}) {
    return (
        <div className="avatar">
            <div className={cn(
                className,
                "bg-base-100 rounded-full",
                size === "xs" && "w-2",
                size === "sm" && "w-4",
                (size === "md") && "w-8",
                size === "lg" && "w-12",
                size === "xl" && "w-16",
            )}>
                <img src={`/api/v1/avatar/${id}`} alt="Avatar" />
            </div>
        </div>
    );
}